/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
// import pdfMake, { JV } from 'addthaifont-pdfmake/build/pdfmake';
// import 'addthaifont-pdfmake/build/vfs_fonts';
import pdfMake from 'pdfmake-thaifont-2/build/pdfmake';
import 'pdfmake-thaifont-2/build/vfs_fonts';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import _ from 'lodash';
import imageToBase64 from '../../utils/functions/imageToBase64';

import currencyFormat from '../../utils/functions/currencyFormat';
// import HeaderMaintenanceReportType1 from './maintenanceOrder/HeadMaintenanceOrderType1';
// import { HeaderMaintenanceReportType2 } from './maintenanceOrder/HeadMaintenanceOrderType2';

dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

async function MaintenVehicleMonthly(order, info, vehicleDetail) {
  const {
    setting: { cmms: cmmsSetting },
  } = info;
  pdfMake.fonts = {
    Sarabun: {
      normal: 'Sarabun-Light.ttf',
      bold: 'Sarabun-Regular.ttf',
      italics: 'Sarabun-LightItalic.ttf',
      bolditalics: 'Sarabun-Italic.ttf',
    },
    Impac: {
      normal: 'impac.ttf',
    },

    FontAwesome: {
      normal: 'FontAwesome_regular.ttf',
      bold: 'FontAwesome_regular.ttf',
    },
  };
  const genMaintenance = (data) => {
    const tableBody = [];
    const minRows = 23; // จำนวนขั้นต่ำที่ต้องมี (ถ้ามีน้อยกว่าจะเติม)

    _.forEach(data, (_data) => {
      const processes = _data?.process || [];
      const rowCount = processes.length > 0 ? processes.length : 1;

      if (processes.length > 0) {
        _.forEach(processes, (p, index) => {
          const middleBorder = [true, true, true, false];
          const lastBorder = [true, true, true, true];

          if (index === 0) {
            tableBody.push([
              {
                text: `${dayjs(_data?.createdAt)
                  .locale('th')
                  .format('DD MMM BBBB')}`,
                border: [true, true, true, true],
                fontSize: 10,
                flexGrow: 1,
                rowSpan: rowCount,
                minHeight: 25,
              },
              {
                text: _data?.cause || '-',
                border: [true, true, true, true],
                fontSize: 10,
                flexGrow: 1,
                rowSpan: rowCount,
                minHeight: 25,
              },
              {
                text: `${index + 1}.${p.operating}`,
                border: rowCount === 1 ? lastBorder : middleBorder,
                fontSize: 10,
                minHeight: 25,
              },
              {
                text: _data?.workrecip || '-',
                border: [true, true, true, true],
                fontSize: 10,
                rowSpan: rowCount,
                minHeight: 25,
              },
            ]);
          } else {
            tableBody.push([
              {},
              {},
              {
                text: `${index + 1}.${p.operating}`,
                border:
                  index === processes.length - 1 ? lastBorder : middleBorder,
                fontSize: 10,
                minHeight: 25,
              },
              {},
            ]);
          }
        });
      } else {
        tableBody.push([
          {
            text: `${dayjs(_data?.createdAt)
              .locale('th')
              .format('DD MMM BBBB')}`,
            border: [true, true, true, true],
            fontSize: 10,
            minHeight: 25,
          },
          {
            text: _data?.cause || '-',
            border: [true, true, true, true],
            fontSize: 10,
            minHeight: 25,
          },
          {
            text: '-',
            border: [true, true, true, true],
            fontSize: 10,
            minHeight: 25,
          },
          {
            text: _data?.workrecip || '-',
            border: [true, true, true, true],
            fontSize: 10,
            minHeight: 25,
          },
        ]);
      }
    });

    // --- เติมแถวว่างกรณีข้อมูลน้อยกว่า minRows ---
    if (tableBody.length < minRows) {
      const emptyRowCount = minRows - tableBody.length;
      for (let i = 0; i < emptyRowCount; i++) {
        tableBody.push([
          { text: ' ', border: [true, true, true, true], minHeight: 25 },
          { text: ' ', border: [true, true, true, true], minHeight: 25 },
          { text: ' ', border: [true, true, true, true], minHeight: 25 },
          { text: ' ', border: [true, true, true, true], minHeight: 25 },
        ]);
      }
    }

    return tableBody;
  };

  const maintenanceData = genMaintenance(order);
  const docDefinition = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [20, 300, 40, 50],
    defaultStyle: {
      font: 'Sarabun',
      fontSize: '8',
    },
    info: {
      title: 'ใบแจ้งซ่อม',
    },
    header: [
      {
        margin: [30, 20, 25, 0],
        style: 'tableExample',
        table: {
          widths: ['30%', '40%', '18%', '12%'],
          body: [
            [
              // ----- คอลัมน์ที่ 1: โลโก้และชื่อบริษัท -----
              {
                rowSpan: 2,
                alignment: 'center',
                border: [true, true, true, true],
                stack: [
                  {
                    image: info?.image_subLogo || info?.image_logo || '',
                    fit: [60, 60],
                    alignment: 'center',
                    margin: [0, 5, 0, 5],
                  },
                  {
                    text: 'THAI TALLOW AND OIL CO.,LTD.',
                    alignment: 'center',
                    fontSize: 12,
                    font: 'Impac',
                  },
                ],
              },
              // ----- คอลัมน์ที่ 2: ชื่อเอกสาร (จัดกึ่งกลาง) -----
              {
                rowSpan: 2,
                text: 'ประวัติการซ่อมบำรุงรักษาเครื่องจักร',
                bold: true,
                fontSize: 13,
                alignment: 'center',
                margin: [0, 25, 0, 0],
              },
              // ----- คอลัมน์ที่ 3, แถวบน: หมายเลขเอกสาร -----
              {
                text: 'เอกสารหมายเลข : FM - EN - 004',
                alignment: 'left',
                colSpan: 2,
                fontSize: 11,
                margin: [0, 8, 0, 8],
                border: [false, true, true, true],
              },
              {
                text: '',
                alignment: 'left',
                fontSize: 11,
                margin: [0, 8, 0, 8],
                border: [false, true, true, true],
              },
            ],
            [
              {
                text: '',
                alignment: 'left',
                bold: true,
                fontSize: '9',
                border: [true, true, false, true],
              },
              {
                text: '',
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [false, true, true, true],
              },
              {
                text: 'บังคับใช้:6 ก.ย. 2564',
                bolditalics: true,
                fontSize: '10',
                alignment: 'left',
                margin: [0, 8, 0, 0],
                border: [true, true, true, true],
              },
              {
                text: 'แก้ไขครั้งที่: 01',
                bold: true,
                fontSize: '10',
                alignment: 'left',
                margin: [0, 8, 0, 0],
                border: [true, true, true, true],
              },
            ],
          ],
        },
      },
      {
        margin: [30, 10, 25, 0],
        style: 'tableExample',
        table: {
          widths: ['30%', '30%', '20%', '20%'],
          body: [
            [
              {
                text: 'ชื่อเครื่องจักร',
                margin: [0, 5, 0, 5],
                alignment: 'left',
                bold: true,
                fontSize: '11',
                border: [true, true, true, true],
              },
              {
                text: `${vehicleDetail?.engname || '-'} \n (${
                  vehicleDetail?.thainame || '-'
                })`,
                bold: true,
                colSpan: 3,
                margin: [0, 5, 0, 5],
                fontSize: '11',
                alignment: 'left',
                border: [false, true, true, true],
              },
              {
                text: '',
                bold: true,
                margin: [0, 5, 0, 5],
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: '',
                bold: true,
                margin: [0, 5, 0, 5],
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
            ],

            [
              {
                text: 'รหัสเครื่องจักร',
                margin: [0, 5, 0, 5],
                alignment: 'left',
                bold: true,
                fontSize: '11',
                border: [true, true, false, true],
              },
              {
                text: vehicleDetail?.licence_number || '-',
                bold: true,
                colSpan: 3,
                margin: [0, 5, 0, 5],
                fontSize: '11',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: '',
                bold: true,
                margin: [0, 5, 0, 5],
                fontSize: '9',
                alignment: 'center',
                border: [true, true, true, true],
              },
              {
                text: '',
                bold: true,
                margin: [0, 5, 0, 5],
                fontSize: '9',
                alignment: 'center',
                border: [true, true, true, true],
              },
            ],
            [
              {
                text: '',
                alignment: 'left',
                bold: true,
                fontSize: '9',
                border: [true, true, false, true],
              },
              {
                text: '',
                bold: true,
                fontSize: '9',
                alignment: 'center',
                border: [true, true, true, true],
              },
              {
                text: 'Motor',
                bold: true,
                fontSize: '11',
                alignment: 'left',
                border: [true, true, false, true],
              },
              {
                text: 'Gear',
                bold: true,
                fontSize: '11',
                alignment: 'left',
                border: [true, true, true, true],
              },
            ],
            [
              {
                text: 'รายละเอียดเครื่องจักร',
                alignment: 'left',
                rowSpan: 4,
                bold: true,
                fontSize: '11',
                border: [true, true, false, true],
              },
              {
                text: 'ยี่ห้อ',
                bold: true,
                fontSize: '11',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: vehicleDetail?.attribute?.moter?.brand || '',
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: vehicleDetail?.attribute?.gear?.brand || '',
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
            ],
            [
              {
                text: '',
                alignment: 'left',
                bold: true,
                fontSize: '9',
                border: [true, true, false, true],
              },
              {
                text: 'รุ่น',
                bold: true,
                fontSize: '11',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: vehicleDetail?.attribute?.moter?.model_name || '',
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: vehicleDetail?.attribute?.gear?.model_name || '',
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
            ],
            [
              {
                text: '',
                alignment: 'left',
                bold: true,
                fontSize: '9',
                border: [true, true, false, true],
              },
              {
                text: 'Capacity',
                bold: true,
                fontSize: '11',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: vehicleDetail?.attribute?.moter?.capacity || '',
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: vehicleDetail?.attribute?.gear?.capacity || '',
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
            ],
            [
              {
                text: '',
                alignment: 'left',
                bold: true,
                fontSize: '9',
                border: [true, true, false, true],
              },
              {
                text: 'ความเร็วรอบ',
                bold: true,
                fontSize: '11',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: `${vehicleDetail?.attribute?.moter?.speed || ''}  rpm`,
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
              {
                text: `${vehicleDetail?.attribute?.gear?.speed || ''}  rpm`,
                bold: true,
                fontSize: '9',
                alignment: 'left',
                border: [true, true, true, true],
              },
            ],
          ],
        },
      },
    ],

    content: [
      {
        margin: [10, 5, -15, 0],
        style: 'tableExample',
        border: [true, true, true, true],
        fontSize: 11,
        table: {
          widths: ['15%', '30%', '40%', '15%'],
          border: [true, true, true, true],
          heights: [10],
          headerRows: 1,
          body: [
            [
              {
                text: 'วัน/เดือน/ปี',
                alignment: 'center',
                rowSpan: 2,
                fontSize: 12,
                border: [true, true, true, true],
                bold: true,
              },
              {
                text: 'การซ่อมบำรุง',
                alignment: 'center',
                colSpan: 2,
                fontSize: 12,
                border: [true, true, true, true],
                bold: true,
              },
              {
                text: '',
                alignment: 'center',
                border: [true, true, true, true],
                bold: true,
              },
              {
                text: 'ผู้ปฏิบัติ',
                alignment: 'center',
                rowSpan: 2,
                fontSize: 12,
                bold: true,
                border: [true, true, true, true],
              },
            ],
            [
              {
                text: '',
                alignment: 'center',
                border: [true, true, true, true],
                bold: true,
              },
              {
                text: 'สาเหตุการชำรุด',
                alignment: 'center',
                margin: [50, 0, 0, 0],
                border: [true, true, true, true],
                bold: true,
              },
              {
                text: 'การซ่อมบำรุง',
                alignment: 'center',
                margin: [50, 0, 0, 0],
                border: [true, true, true, true],
                bold: true,
              },
              {
                text: '',
                alignment: 'center',
                bold: true,
                border: [true, true, true, true],
              },
            ],
            ...maintenanceData,
          ],
        },
      },
    ],
    styles: {
      icon: {
        font: 'FontAwesome',
        alignment: 'center',
        fontSize: 10,
      },
    },
    images: {
      // Add null check for images
      logo: info?.image_subLogo || info?.image_logo || '', // Provide fallback
    },
  };

  pdfMake.createPdf(docDefinition).open();
}
export default MaintenVehicleMonthly;
